import { render } from "./Forgotpassword.vue?vue&type=template&id=f96c21a8&scoped=true"
import script from "./Forgotpassword.vue?vue&type=script&lang=js"
export * from "./Forgotpassword.vue?vue&type=script&lang=js"

import "./Forgotpassword.vue?vue&type=style&index=0&id=f96c21a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96c21a8"]])

export default __exports__